export const rankingBigViewBreakpoint = "1192px";
